export default __webpack_public_path__ + "static/media/OntimeMRP-logo-white.c1556f54.png";